import React from 'react';

import BaseCell from '../BaseCell';
import Checkbox, { CheckboxState, OnChangeParams } from '../../../Checkbox';

export interface CheckboxCellProps {
  value?: CheckboxState;
  onChange: (params: OnChangeParams) => void;
  disabled?: boolean;
}

const CheckboxCell: React.FC<CheckboxCellProps> = ({ value = 'off', onChange, disabled }) => {
  const handleChange = (params: OnChangeParams) => {
    params.event.stopPropagation();
    onChange(params);
  };

  return (
    <BaseCell position="relative">
      <Checkbox size="md" value={value} onChange={handleChange} disabled={disabled} />
    </BaseCell>
  );
};

export default CheckboxCell;
